export default [
  {
    path: '/activity-20260811-main',
    component: () => import('./Page.vue'),
    meta: {
      title: '头条风云季',
    },
  },
]
